import { Link } from 'react-router-dom';
import './Servicios.css';

const services = [
  {
    icon: '🤖',
    title: 'Agentes IA para Ventas',
    desc: 'Automatiza todo tu embudo de ventas. Desde la captación de leads hasta el cierre, nuestros agentes trabajan 24/7 sin descanso.',
    features: ['Seguimiento automático de prospectos', 'Generación de cotizaciones con IA', 'Integración con WhatsApp y CRM', 'Reportes de conversión en tiempo real'],
  },
  {
    icon: '💬',
    title: 'Atención al Cliente IA',
    desc: 'Chatbots inteligentes entrenados con la información de tu empresa. Resuelven dudas, procesan solicitudes y escalan casos complejos.',
    features: ['Disponibilidad 24/7 sin costo extra', 'Entrenado con tu catálogo y FAQs', 'Escalamiento inteligente a humanos', 'Multicanal: web, WhatsApp, Instagram'],
  },
  {
    icon: '📊',
    title: 'Análisis de Datos con IA',
    desc: 'Transforma tus datos en decisiones estratégicas. Dashboards automáticos, predicciones y reportes generados por inteligencia artificial.',
    features: ['Dashboards automáticos personalizados', 'Predicción de demanda y tendencias', 'Reportes ejecutivos generados con IA', 'Integración con tus sistemas actuales'],
  },
  {
    icon: '📱',
    title: 'Estrategia y Redes Sociales',
    desc: 'Gestión inteligente de redes sociales con contenido generado y optimizado por IA. Más alcance, menos tiempo.',
    features: ['Creación de contenido con IA', 'Calendario editorial automatizado', 'Análisis de audiencia y competencia', 'Gestión de LinkedIn, Instagram y Facebook'],
  },
  {
    icon: '🏛️',
    title: 'Transformación Digital Sector Público',
    desc: 'Consultoría especializada para alcaldías y entidades departamentales. Implementación de IA dentro del marco normativo colombiano.',
    features: ['Diagnóstico de madurez digital', 'Diseño de estrategia TIC institucional', 'Automatización de trámites y servicios', 'Capacitación a servidores públicos'],
  },
  {
    icon: '🎯',
    title: 'Consultoría en Adopción de IA',
    desc: 'Acompañamos a tu empresa en el proceso de adopción de inteligencia artificial, desde la estrategia hasta la implementación.',
    features: ['Diagnóstico de procesos automatizables', 'Hoja de ruta de implementación IA', 'Selección de herramientas y plataformas', 'Seguimiento y medición de resultados'],
  },
];

export default function Servicios() {
  return (
    <main className="servicios-page">
      <section className="page-hero">
        <div className="page-hero__bg">
          <div className="page-hero__orb" />
        </div>
        <div className="container page-hero__content">
          <div className="tag">Servicios</div>
          <h1 className="page-hero__title">IA aplicada a cada<br /><span>área de tu negocio</span></h1>
          <p className="page-hero__sub">Soluciones prácticas de inteligencia artificial para empresas e instituciones públicas del Tolima y Colombia.</p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="servicios-grid">
            {services.map((s, i) => (
              <div className="servicio-card" key={i}>
                <div className="servicio-card__top">
                  <span className="servicio-card__icon">{s.icon}</span>
                  <h3>{s.title}</h3>
                  <p>{s.desc}</p>
                </div>
                <ul className="servicio-card__features">
                  {s.features.map((f, j) => (
                    <li key={j}><span className="check">✓</span>{f}</li>
                  ))}
                </ul>
                <Link to="/contacto" className="btn-outline servicio-card__cta">Solicitar información →</Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section-sm">
        <div className="container">
          <div className="cta-box" style={{textAlign:'center', padding:'64px 40px'}}>
            <div className="tag">¿No sabes por dónde empezar?</div>
            <h2 style={{fontFamily:'var(--font-display)', fontSize:'clamp(24px,3.5vw,36px)', fontWeight:500, color:'var(--aire)', marginBottom:16}}>Agenda una sesión de diagnóstico gratuita</h2>
            <p style={{color:'var(--luz)', marginBottom:28, maxWidth:480, margin:'0 auto 28px'}}>En 30 minutos identificamos qué procesos de tu empresa pueden automatizarse con IA y cuánto impacto generaría.</p>
            <Link to="/contacto" className="btn-primary">Agendar sesión gratuita →</Link>
          </div>
        </div>
      </section>
    </main>
  );
}
